import React, { useState } from 'react';
import {
    Box,
    Container,
    Typography,
    TextField,
    Button,
    Grid,

} from '@mui/material';
import useDeleteAccount from '../../hooks/account/useDeleteAccount';

function App() {
    const { sendEmail } = useDeleteAccount();
    const [formDelete, setFormDelete] = useState({
        nome: '',
        email: '',
        telefone: '',
        motivoExclusao: '',
    });

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setFormDelete(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (formDelete.email !== '') {
            await sendEmail(formDelete.email)
        }
    };

    return (
        <Container maxWidth="md">
            <Box mt={4} mb={4}>
                <Grid
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '20px',
                    }}
                >
                    <img
                        src="//img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=h:75,cg:true,m/qt=q:95"
                        srcSet="//img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=w:303,h:75,cg:true,m/cr=w:303,h:75/qt=q:95, //img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=w:607,h:150,cg:true,m/cr=w:607,h:150/qt=q:95 2x, //img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=w:910,h:225,cg:true,m/cr=w:910,h:225/qt=q:95 3x"
                        alt="Fretapp - Entregando Soluções"
                    />
                </Grid>
            </Box>

            <Box sx={{ my: 4 }}>
                <Typography variant="h5" component="h1" gutterBottom>
                    NÓS DA FRETAPP RESPEITAMOS A SUA PRIVACIDADE E O DIREITO DE CONTROLAR SEUS DADOS
                </Typography>
                <Typography variant="body2" paragraph>
                    Se você deseja solicitar a exclusão de seus dados de nossa plataforma, leia as informações abaixo e preencha o formulário. Por favor, considere o seguinte antes de enviar sua solicitação:
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <ul>
                        <li>Ao solicitar a exclusão de seus dados, você não terá mais acesso ao aplicativo Fretapp e todas as informações associadas ao seu perfil serão permanentemente removidas</li>
                        <li>A exclusão se refere estritamente às suas credenciais de acesso e dados relacionados ao uso do aplicativo.</li>
                        <li>Pode levar até 30 dias para que sua solicitação seja processada e seus dados sejam completamente removidos de nossos sistemas.</li>
                        <li>Se você decidir retornar ao aplicativo da Fretapp no futuro, precisará criar um novo perfil e fornecer todas as informações novamente.</li>
                    </ul>
                </Box>
                <form onSubmit={handleSubmit}>
                    <Typography variant="h5" component="h2" gutterBottom>
                        Solicitação de Exclusão de Dados do Usuário
                    </Typography>
                    <TextField
                        fullWidth
                        label="Nome"
                        name="nome"
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        required
                    />
                    <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        required
                    />
                    <TextField
                        fullWidth
                        label="Telefone"
                        name="telefone"
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        required
                    />
                    <TextField
                        fullWidth
                        label="Motivo da Exclusão"
                        name="motivoExclusao"
                        multiline
                        rows={4}
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        required
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button type="submit" variant="contained" color="primary">
                            Enviar
                        </Button>
                    </Box>
                </form>
                <Box sx={{ my: 4 }}>
                    <Typography paragraph>
                        Após enviar sua solicitação, nossa equipe revisará e processará sua demanda o mais rápido possível.
                        Você receberá um e-mail confirmando que seus dados foram excluídos de nossos sistemas assim que o processo for concluído.
                    </Typography>
                </Box>
            </Box>
        </Container>
    );
}

export default App;
